<form [formGroup]="filterForms" (ngSubmit)="checkAndCallMethods()">
    <div>
        <!-- Filter dropdown -->
        @if (localTableFilters) {
        <mat-form-field class="filter">
            <mat-label>Filter</mat-label>
            <mat-select formControlName="tableFilter" (selectionChange)="changeValue($event.value)"
                [compareWith]="compareFilters">
                @for (filter of localTableFilters; track $index) {
                <mat-option [value]="filter">
                    {{filter.displayName}}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        }

        <!-- Dynamic value input -->
        @if (filterForms.value?.tableFilter) {
        <mat-form-field class="filter">
            <mat-label>{{filterForms.value.tableFilter.displayName || ''}}</mat-label>

            @if (isArray() && filterForms.value.tableFilter.displayName !== 'Work Order Type' &&
            !(filterForms.value.tableFilter.displayName === 'Date' && filterForms.value.tableFilter.values.length == 1))
            {
            <mat-select formControlName="value" (selectionChange)="onValueSelected($event.value)">
                @for (val of filterForms.value.tableFilter.values; track $index) {
                <mat-option [value]="val">
                    {{val}}
                </mat-option>
                }
            </mat-select>
            } @else {

            @if (filterForms.value.tableFilter.displayName !== 'Work Order Type'
            && !(filterForms.value.tableFilter.displayName === 'Date'
            && filterForms.value.tableFilter.values.length == 1)) {
            <input matInput placeholder="{{filterForms.value.tableFilter.displayName || ''}}" formControlName="value">
            }

            <!-- Case: Text input -->
            <!-- @if (!isArrayType && !(filterForms.value.tableFilter.values && filterForms.value.tableFilter.values.length >
            0) && !isWorkOrderType && !isSingleDateValue && !dateFilterSelected) {
            <input matInput placeholder="{{filterForms.value.tableFilter.displayName || ''}}" formControlName="value">
            } -->

            }

            <!-- @if (filterForms.value.tableFilter.displayName === 'Work Order Type') {
            <mat-select formControlName="value">
                @for (workOrder of workOrderOptions; track $index) {
                @if (us == true || asia == true) {
                <mat-option [value]="workOrder">
                    {{workOrder}}
                </mat-option>
                }
                }
                @for (workOrder of workOrderOptions; track $index) {
                @if (europe == true) {
                <mat-option [value]="workOrder">
                    {{workOrder}}
                </mat-option>
                }
                }
            </mat-select>
            } -->

            <!-- Case: Work Order Type -->
            @if (isWorkOrderType) {
            <mat-select formControlName="value">
                @for (workOrder of workOrderOptions; track $index) {
                <mat-option [value]="workOrder">
                    {{ workOrder }}
                </mat-option>
                }
            </mat-select>
            }

            @if (isArray() && filterForms.value.tableFilter.displayName !== 'Work Order Type' &&
            (filterForms.value.tableFilter.displayName === 'Date' && filterForms.value.tableFilter.values.length == 1))
            {
            <mat-select [value]="filterForms.value.tableFilter.values[0]" [disabled]="true" formControlName="value">
                <mat-option [value]="filterForms.value.tableFilter.values[0]">
                    {{filterForms.value.tableFilter.values[0]}}
                </mat-option>
            </mat-select>
            }
        </mat-form-field>
        }
        <!-- Date range picker (shows only after selecting Date Received or Scheduled Start Date) -->
        @if (dateFilterSelected && filterForms.value?.tableFilter?.displayName === 'Date' && filterForms.value?.value) {
        <mat-form-field subscriptSizing="dynamic" class="filter">
            <mat-label>Choose date range</mat-label>
            <input matInput type="text" bsDaterangepicker [bsConfig]="bsConfig" [minDate]="minDate" [maxDate]="maxDate"
                [(ngModel)]="bsRangeValue" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
        }

        <!-- Action buttons -->
        <div class="buttons">
            <button mat-flat-button color="primary" class="button" type="submit" [disabled]="isFilterSet()"
                (click)="isAddFilterClicked()">Add</button>
            <button mat-flat-button color="primary" class="button" type="submit" [disabled]="!isWONumberFilterApplied()"
                (click)="isSearchClicked()">Search</button>
            <button mat-flat-button color="primary" class="button" [disabled]="!isWONumberFilterApplied()"
                (click)="isExcelClicked()">Export</button>
            <button mat-stroked-button class="button" [disabled]="!isAnyFilterSet()" (click)="reset()">Reset</button>
        </div>

        <!-- Chips display -->
        @if (filterAdded) {
        <div class="chips">
            <mat-chip-set class="example-chip-list" aria-label="Filter selection">
                @for (filters of filterArray; track filters.value) {
                <mat-chip (removed)="remove(filters.value)">
                    {{filters.dispalyName}} - {{filters.value}}
                    @if (removable) {
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                    }
                </mat-chip>
                }
            </mat-chip-set>
        </div>
        }
    </div>
</form>



<!-- Loading spinner -->
@if (isLoadingResults) {
<div class="loading-shade">
    <mat-spinner></mat-spinner>
</div>
}